/** Shared STAVBOŠ moderation helpers — keep in sync with stavbos/backend/moderation.py */

const LOAN_PHRASES = [
  "půjčka",
  "pujcka",
  "půjčku",
  "pujcku",
  "půjčky",
  "pujcky",
  "půjčkou",
  "pujckou",
  "rychlá půjč",
  "legitimní půjč",
  "soukromé osob",
  "soukrome osob",
  "loan from",
  "payday loan",
  "easy loan",
  "investment in your country",
  "making an investment",
];

const SPAM_SENDERS = [
  "mikhailotrokhym@outlook.com",
  "veravocaskova019@gmail.com",
  "jryzova@gmail.com",
];

const SPAM_NAME_PHRASES = ["mikhailo trokhym", "mikhailo troklyym"];

function normalize(text) {
  return String(text || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

function haystack(parts) {
  return normalize(parts.filter(Boolean).join(" \n "));
}

export function isTopActive(ad, now = new Date()) {
  if (!ad || !ad.is_top) return false;
  if (!ad.top_until) return false;
  const until = new Date(ad.top_until);
  if (Number.isNaN(until.getTime())) return false;
  return until.getTime() > now.getTime();
}

export function listingSpamReason({ title, description, location, contact_email } = {}) {
  const text = haystack([title, description]);
  // "půjčka" (pujcka) must not match valid "půjčovna" (pujcovna).
  for (const phrase of LOAN_PHRASES) {
    if (text.includes(normalize(phrase))) {
      return "Inzeráty na půjčky a finanční služby na STAVBOŠ nezveřejňujeme.";
    }
  }
  const loc = String(location || "").trim();
  if (loc && /^\d{4,6}$/.test(loc)) {
    return "Zadejte město nebo adresu, ne jen PSČ.";
  }
  const email = normalize(contact_email);
  if (email && SPAM_SENDERS.includes(email)) {
    return "Tento kontakt je zablokovaný kvůli spamu.";
  }
  return null;
}

export function contactSpamReason({ sender_name, sender_email, message } = {}) {
  const email = normalize(sender_email);
  if (email && SPAM_SENDERS.includes(email)) {
    return "Tato zpráva vypadá jako spam a nebyla odeslána.";
  }
  const name = normalize(sender_name);
  if (SPAM_NAME_PHRASES.some((p) => name.includes(normalize(p)))) {
    return "Tato zpráva vypadá jako spam a nebyla odeslána.";
  }
  const text = haystack([message, sender_name]);
  if (text.includes("investment in your country") || text.includes("making an investment")) {
    return "Tato zpráva vypadá jako spam a nebyla odeslána.";
  }
  return null;
}
